// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#Customize .ant-form-item {\n  margin: 10px;\n}\n#Customize input {\n  width: 135px;\n}\n#Customize .ant-space-item > span {\n  margin-top: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
